import { useState, useCallback } from "react";
import { useRecoilState } from "recoil";
import { StripePaystationState, xsollaModalOpen } from "../../State";
import { useUser } from "../useUser";
import { analytics } from "../../Analytics";

const ENDPOINT = process.env.REACT_APP_STRIPE_ENDPOINT;

export const useManageSubscription = () => {
  const { allstarUser } = useUser();
  const [paystation, setPaystationOpen] = useRecoilState(StripePaystationState);
  const [xsollaPaystation, setXsollaPaystationOpen] =
    useRecoilState(xsollaModalOpen);
  const [retentionOpen, setRetentionOpen] = useState(false);

  const userGroupType = allstarUser?.user?.userGroup?.type;
  const isTrialPeriod = allstarUser?.user?.userGroup?.isTrialPeriod;
  const isStripeUser = allstarUser?.user?.credits?.providerName === "STRIPE";

  const canManageBilling = allstarUser?.user?.canManageBilling === true;
  const isActiveSubscriber = userGroupType !== "FREE" || canManageBilling;

  const fetchStripePortalUrl = useCallback(async () => {
    const res = await fetch(`${ENDPOINT}/stripe/v1/request`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${allstarUser.token}`,
      },
    });
    const data = await res.json();
    return data.portal as string;
  }, [allstarUser.token]);

  const proceedToManage = useCallback(async () => {
    if (isStripeUser) {
      setPaystationOpen({
        ...paystation,
        type: "session",
        isModalOpen: true,
        portalUrl: undefined,
      });
      const url = await fetchStripePortalUrl();
      setPaystationOpen({
        ...paystation,
        type: "session",
        isModalOpen: true,
        portalUrl: url,
      });
      window?.open(url, "_blank")?.focus();
    } else {
      setXsollaPaystationOpen({
        ...xsollaPaystation,
        type: "manage",
        isModalOpen: true,
      });
    }
  }, [
    isStripeUser,
    paystation,
    setPaystationOpen,
    fetchStripePortalUrl,
    xsollaPaystation,
    setXsollaPaystationOpen,
  ]);

  const handleManageSubscription = useCallback(
    async (trackingLocation?: string) => {
      analytics.track("Manage Subscription Click", {
        location: trackingLocation || "Unknown",
      });

      setRetentionOpen(true);
    },
    [],
  );

  const handleRetentionClose = useCallback(() => {
    setRetentionOpen(false);
  }, []);

  const handleRetentionSkip = useCallback(() => {
    setRetentionOpen(false);
    proceedToManage();
  }, [proceedToManage]);

  return {
    isActiveSubscriber,
    isStripeUser,
    handleManageSubscription,
    fetchStripePortalUrl,
    retentionOpen,
    handleRetentionClose,
    handleRetentionSkip,
  };
};
